import { CurrencyRatesKeyType } from '../../keys';

const currencyRates: CurrencyRatesKeyType = {
  priceIn: 'Price in',
  exchangeRate: 'Exchange rate'
};

export default currencyRates;
